/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { TransformationApiData } from "./TransformationApiData";
export const TransformationsResponse = core.serialization.object({
    success: core.serialization.boolean(),
    data: core.serialization.list(TransformationApiData),
});
